import React from "react";
import CustomInput from "../../../components/CustomForm/CustomInput";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";
import useEmpresa from "../../../hooks/useEmpresa";
import CustomIconInput from "../../../components/CustomForm/CustomIconInput";
import { Avatar } from "../../../components/Common/CommonStyles";
import Colors from "../../../themes/Colors";
import Tooltip from "../../../components/Common/Tooltip";
import CustomIcon from "../../../components/Common/CustomIcon";
import { SearchOutlined, DeleteOutlined } from "@ant-design/icons";

const AfiliadoForm = ({
  queryAfiliado,
  cedula,
  nss,
  nombres,
  apellidos,
  edad,
  foto,
  onStateChange,
  onSearch,
  onClean,
  onQueryAfiliadoChange,
  disabled
}) => {
  const empresa = useEmpresa();

  return (
    <FormWrapper
      flexDirection={"row"}
      flex={"1"}
      borderColor={empresa?.COLOR_PRINCIPAL}
    >
      <FormWrapper borderColor={Colors.transparent} maxWidth={"100px"}>
        <Avatar src={foto} />
      </FormWrapper>

      <FormWrapper borderColor={Colors.transparent}>
        <Form>
          <FormGroup>
            <CustomIconInput
              type={"text"}
              width={"150px"}
              placeholder={"Número de " + empresa?.TIPO_CLIENTE}
              label={empresa?.TIPO_CLIENTE}
              value={queryAfiliado}
              position={"absolute"}
              disabled={disabled}
              onChange={onQueryAfiliadoChange()}
              icons={
                <>
                  <Tooltip text="Buscar">
                    <CustomIcon
                      icon={SearchOutlined}
                      style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 30 }}
                      hoverColor={empresa?.COLOR_SECUNDARIO}
                      onClick={onSearch}
                    />
                  </Tooltip>
                  <Tooltip text="Limpiar">
                    <CustomIcon
                      icon={DeleteOutlined}
                      style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 30 }}
                      hoverColor={empresa?.COLOR_SECUNDARIO}
                      onClick={onClean}
                    />
                  </Tooltip>
                </>
              }
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Cédula"}
              label={"Cédula"}
              value={cedula}
              disabled={true}
              onChange={onStateChange("cedula")}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"NSS"}
              label={"NSS"}
              value={nss}
              disabled={true}
              onChange={onStateChange("nss")}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Nombres"}
              label={"Nombres"}
              value={nombres}
              disabled={true}
              onChange={onStateChange("nombres")}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Apellidos"}
              label={"Apellidos"}
              value={apellidos}
              disabled={true}
              onChange={onStateChange("apellidos")}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Edad"}
              label={"Edad"}
              value={edad}
              disabled={true}
              onChange={onStateChange("edad")}
            />
          </FormGroup>
        </Form>
      </FormWrapper>
    </FormWrapper>
  );
};

export default AfiliadoForm;